import { useLazyQueryNoCache } from 'Shared/Hooks/useApolloClient'
import validateMembershipQuery from 'Shared/Queries/ValidateMembershipQuery'

const useMembershipValidation = () => {
  const [validate, { data, loading, error }] = useLazyQueryNoCache(validateMembershipQuery)

  const validateMembership = ({ code, email, slug, dates, isDailyAccommodation, isExclusive }) => {
    validate({ variables: { slug, code, email, dates, isDailyAccommodation, isExclusive } })
  }

  return { validateMembership, data, loading, error }
}

export default useMembershipValidation
